import { render, staticRenderFns } from "./LaboratoriesList.vue?vue&type=template&id=093fb5ea"
import script from "./LaboratoriesList.vue?vue&type=script&lang=js"
export * from "./LaboratoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports